// useSaveKey (QA-058): one idempotency key per attempt at the same write, so pressing it again after a
// lost answer can't do it twice. SaveButton.tsx re-exports it; a form drawn with ui-web's Button
// (Customers' Add customer in Blueprint) takes it from here.
import { useRef, useState } from 'react';
import { attemptKeys, type AttemptKeys } from './attempt-keys.ts';

/**
 * One idempotency key for one attempt at the same write. Retrying the same form reuses it, so a
 * write whose answer was lost lands at most once; a change to the form (`signature`), or `renew()`
 * after a success, starts a new one. Pass it as `client.call(action, input, { idempotencyKey })`.
 */
export function useSaveKey(signature: string): { key: string; renew: () => void } {
  const held = useRef<AttemptKeys | null>(null);
  held.current ??= attemptKeys();
  const keys = held.current;
  const [, bump] = useState(0);
  return {
    key: keys.key('save', signature),
    renew: () => {
      keys.end('save');
      bump((n) => n + 1);
    },
  };
}
